import { browser } from '$app/environment';
import { writable, derived } from 'svelte/store';

export interface ClientNotification {
  id: string;
  message: string;
}

const DISMISSED_COOKIE_NAME = 'dismissed_notifications';
const COOKIE_EXPIRY_DAYS = 30;

const HARDCODED_NOTIFICATIONS: ClientNotification[] = [
  // Add notifications here as needed, e.g.:
  // {
  //   id: [UUID],
  //   message: 'Example notification message with <a href="https://example.com">a link</a>.' }
  // }
];

function getCookieDomain(): string {
  if (!browser) return '';
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  if (parts.length > 2) return parts.slice(1).join('.');
  return hostname;
}

function getDismissedIds(): string[] {
  if (!browser) return [];

  const cookies = document.cookie.split('; ');
  const cookie = cookies.find((str) => str.startsWith(`${DISMISSED_COOKIE_NAME}=`));

  if (!cookie) return [];

  const value = cookie.replace(`${DISMISSED_COOKIE_NAME}=`, '');
  return value.split(',').filter((id) => id.trim() !== '');
}

function setDismissedIds(ids: string[]): void {
  if (!browser) return;

  const domain = getCookieDomain();
  const expires = new Date();
  expires.setDate(expires.getDate() + COOKIE_EXPIRY_DAYS);

  document.cookie = `${DISMISSED_COOKIE_NAME}=${ids.join(',')};domain=${domain};path=/;expires=${expires.toUTCString()};SameSite=Strict`;
}

function getInitialNotifications(): ClientNotification[] {
  const dismissedIds = getDismissedIds();
  return HARDCODED_NOTIFICATIONS.filter((n) => !dismissedIds.includes(n.id));
}

export const notifications = writable<ClientNotification[]>(getInitialNotifications());

export const hasActiveNotifications = derived(notifications, ($notifications) => $notifications.length > 0);

export function dismissNotification(id: string): void {
  const dismissedIds = getDismissedIds();

  if (!dismissedIds.includes(id)) {
    dismissedIds.push(id);
    setDismissedIds(dismissedIds);
  }

  notifications.update((current) => current.filter((n) => n.id !== id));
}
